
import { Component, Vue } from 'vue-property-decorator';
import SectionCategoriesKpiCard from '../../components/KPIs/SectionCategoriesKpiCard.vue';
import RouteTitle from '@/components/RouteTitle.vue';
import UIUtil from '@/utils/ui.util';
import RouterUtil from '@/utils/router.util';
import { RouteConfig } from 'vue-router';

@Component({
  components: {
    RouteTitle,
    SectionCategoriesKpiCard,
  },
})
export default class SectionCategoriesKpiCards extends Vue {
  sections: RouteConfig[] = [];

  generateSrc(fileName: string): string {
    return UIUtil.generateImagePathbyFileName(fileName);
  }

  getPath(child: RouteConfig): string {
    return `${this.$route.path}/${child.path}`;
  }

  sortRoutes(a: RouteConfig, b: RouteConfig): number {
    if (a.meta && a.meta.userAllowed && (!b.meta || !b.meta.userAllowed))
      return -1;
    if (b.meta && b.meta.userAllowed && (!a.meta || !a.meta.userAllowed))
      return 1;
    return 0;
  }

  getCards(): void {
    this.sections = RouterUtil.getChildrenByParentPath(
      this.$route.path,
      this.$store.state.user.userRoutes
    ).filter(
      (router) =>
        !router.meta?.hiddenOnNavigation &&
        router.meta?.active !== false &&
        (router.meta?.userAllowed || router.meta?.isAccessGloboButtonEnabled)
    );
    this.sections.sort(this.sortRoutes);
  }

  get disableCard(): boolean {
    return this.$route.meta && this.$route.meta.disableCard
      ? this.$route.meta.disableCard
      : '';
  }

  mounted(): void {
    this.getCards();
  }
}
